module.exports = __webpack_public_path__ + "img/box4.7ef9908b.png";